"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = __importStar(require("react"));
var theme_ui_1 = require("theme-ui");
var colors_1 = __importDefault(require("../../../theme/colors"));
var typography_1 = __importDefault(require("../../../theme/typography"));
var Label_1 = require("../../atoms/Label/Label");
var InputLabel = function (_a) {
    var _b, _c, _d;
    var label = _a.label, id = _a.id, _e = _a.adornments, adornments = _e === void 0 ? [] : _e, labelVariant = _a.labelVariant, _f = _a.containerSX, containerSX = _f === void 0 ? {} : _f, _g = _a.labelSX, labelSX = _g === void 0 ? {} : _g, children = _a.children;
    var pr = adornments.length > 0 ? { pr: 1 } : {};
    /**
     * This effect's purpose is to avoid Chrome's bug.
     * In forms.ts file we're calling a void animation on -webkit-autofill,
     * then here in this component we're listening for an event (animationstart).
     * If animation starts, that means that inputs were autofilled and then
     * we're pulling up the labels.
     *
     * Chrome bug:
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1166619
     */
    react_1.useEffect(function () {
        var inputLabelStyle = "\n            top: 0;\n            transform: \"translateY(-50%)\";\n            background: linear-gradient(to top, " + colors_1.default.backgroundBlue + " calc(50% + 2.5px), transparent calc(50% + 2.5px));\n            fontSize: 0;\n            fontWeight: " + typography_1.default.fontWeights.bold + ";\n            letterSpacing: " + typography_1.default.letterSpacing.largeHeading + ";\n        ";
        var inputs = document.querySelectorAll("input:not([type='checkbox'])");
        // For each input we're searching its label and adding styles to it
        inputs.forEach(function (input) {
            input.addEventListener("animationstart", function (_a) {
                var _b;
                var target = _a.target;
                (_b = target.labels) === null || _b === void 0 ? void 0 : _b.forEach(function (label) { return label.style.cssText = inputLabelStyle; });
            }, false);
        });
    });
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign({ width: "100%", mb: 2 }, containerSX) }, react_1.cloneElement(children, {
        placeholder: (_b = children.props.placeholder) !== null && _b !== void 0 ? _b : label,
        csx: __assign(__assign({}, pr), ((_c = children.props.csx) !== null && _c !== void 0 ? _c : {}))
    }, (theme_ui_1.jsx(react_1.default.Fragment, null,
        theme_ui_1.jsx(Label_1.Label, { variant: labelVariant, htmlFor: (_d = children.props.id) !== null && _d !== void 0 ? _d : children.props.htmlName, isValid: children.props.isValid, csx: labelSX, id: id }, label),
        /**
         * TODO: Decide is we should move adornments into a different place
         */
        adornments.length > 0 && (theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                minWidth: "unset",
                m: 0,
                mr: 2,
                ml: 1,
                alignItems: "center"
            } }, adornments.map(function (adornment, idx) {
            return (theme_ui_1.jsx(theme_ui_1.Flex, { key: idx, sx: {
                    minWidth: "unset",
                    ":not(:last-child)": {
                        mr: 1,
                    }
                } }, typeof adornment === "string" ? (theme_ui_1.jsx(theme_ui_1.Text, null, adornment)) : (adornment)));
        }))))))));
};
exports.InputLabel = InputLabel;
